(function () {
  'use strict';

  angular.module('app').service('HotelContentModalService', HotelContentModalService);

  HotelContentModalService.$inject = ['ModalService'];

  function HotelContentModalService(ModalService) {
    var service = {
      openHotelContentsModal: openHotelContentsModal,
      openHotelContentTranslationsModal: openHotelContentTranslationsModal,
    };

    return service;

    ////////////////

    // --------------------------- openHotelContentsModal -------------------------

    function openHotelContentsModal(hotel) {
      ModalService.showModal({
        templateUrl: './app/ajs/hotel-contents/modals/hotel-contents-modal.html',
        controller: HotelContentsModalCtrl,
        controllerAs: 'vm',
        inputs: {
          hotel: hotel,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      HotelContentsModalCtrl.$inject = [
        '$element',
        'UtilService',
        'AbilityService',
        '$location',
        'HotelService',
        'HotelContentService',
        'SessionService',
        'hotel',
      ];
    }

    function HotelContentsModalCtrl(
      $element,
      UtilService,
      AbilityService,
      $location,
      HotelService,
      HotelContentService,
      SessionService,
      hotel
    ) {
      var vm = this;

      vm.UtilService = new UtilService(vm);

      vm.permissions = {
        canShow: AbilityService.can('show_hotel_accountadmin'),
        canCreate: AbilityService.can('create_hotel_accountadmin'),
        canUpdate: AbilityService.can('update_hotel_accountadmin'),
        canDestroy: AbilityService.can('destroy_hotel_accountadmin'),
      };

      vm.hotel = hotel;
      vm.modalTitle = hotel.name;

      // Methods
      vm.showContent = showContent;
      vm.deleteContent = deleteContent;
      vm.changeContentStatus = changeContentStatus;
      vm.changeContentPublished = changeContentPublished;
      vm.addContent = addContent;

      var companyWebsites = SessionService.getSelectedAccountCompany().websites;

      // Initializers
      setHotelContents();
      setAvailableWebsites();

      function setHotelContents() {
        vm.usedCompanyWebsites = [];

        var hotelContents = [];

        if (vm.hotel.hotel_contents) {
          vm.hotel.hotel_contents.forEach(function (content) {
            for (var i = 0; i < companyWebsites.length; i++) {
              var companyWebsite = companyWebsites[i];
              if (content && companyWebsite.id === content.website_id) {
                content.website_name = companyWebsite.name;
                vm.usedCompanyWebsites.push(companyWebsite);
                break;
              }
            }

            hotelContents.push(content);
          });
        }

        vm.hotel.contents = hotelContents;
      }

      function setAvailableWebsites() {
        vm.availableCompanyWebsites = [];

        for (var i = 0; i < companyWebsites.length; i++) {
          var companyWebsite = companyWebsites[i];
          var found = false;
          for (var j = 0; j < vm.usedCompanyWebsites.length; j++) {
            var usedCompanyWebsite = vm.usedCompanyWebsites[j];
            if (companyWebsite.id === usedCompanyWebsite.id) {
              found = true;
              break;
            }
          }

          if (!found) {
            vm.availableCompanyWebsites.push(companyWebsite);
          }
        }
      }

      function getHotel() {
        HotelService.getHotel(hotel.id).then(function (data) {
          vm.hotel = data;

          setHotelContents();
          setAvailableWebsites();
        });
      }

      function showContent(content) {
        if (!vm.permissions.canShow) {
          return;
        }

        setTimeout(function () {
          // Delay x sec
          $location.path(`/hotel_contents/${content.id}`).search({ WSID: content.website_id });
        }, 100);

        $element.modal('hide'); // bootstrap fade
      }

      function deleteContent(content) {
        HotelContentService.deleteHotelContent(content, getHotel);
      }

      function changeContentStatus(content) {
        HotelContentService.changeHotelContentStatus(content);
      }

      function changeContentPublished(content) {
        HotelContentService.changeHotelContentPublished(content);
      }

      function addContent() {
        if (!vm.permissions.canCreate) {
          return;
        }

        setTimeout(function () {
          // Delay x sec
          $location
            .path(`/hotel_contents/new`)
            .search({ WSID: vm.website.id, hotelId: vm.hotel.id });
        }, 100);

        $element.modal('hide'); // bootstrap fade
      }
    }

    // --------------------------- openHotelContentTranslationsModal -------------------------

    function openHotelContentTranslationsModal(itemId, websiteName, additionalLanguages) {
      ModalService.showModal({
        templateUrl: './app/ajs/hotel-contents/modals/hotel-content-detail-translation.html',
        controller: HotelContentTranslationsModalCtrl,
        controllerAs: 'vm',
        inputs: {
          itemId: itemId,
          websiteName: websiteName,
          additionalLanguages: additionalLanguages,
        },
      }).then(function (modal) {
        var preventModalClose = {
          backdrop: 'static',
          keyboard: false,
        };

        modal.element.modal(preventModalClose);
      });

      HotelContentTranslationsModalCtrl.$inject = [
        'UtilService',
        'HotelContentService',
        'TagService',
        'itemId',
        'websiteName',
        'additionalLanguages',
      ];
    }

    function HotelContentTranslationsModalCtrl(
      UtilService,
      HotelContentService,
      TagService,
      itemId,
      websiteName,
      additionalLanguages
    ) {
      var vm = this;

      vm.UtilService = new UtilService(vm);

      vm.additionalLanguages = additionalLanguages;

      // Methods
      vm.getContent = getContent;
      vm.updateItem = updateItem;

      vm.tagTransform = tagTransform;
      vm.checkTagOptions = checkTagOptions;

      // Initializers
      getContent(additionalLanguages[0].lang);

      function getContent(language) {
        HotelContentService.getHotelContent(itemId, language).then(function (data) {
          vm.item = data;

          vm.modalTitle = vm.item.name + ' (' + websiteName + ')';

          vm.urlEmbedVideo = vm.UtilService.embedYouTubeVideo(vm.item.url_video);

          vm.languageSelected = language;

          getTags(language);
        });
      }

      function updateItem(isFormValid, language) {
        vm.formErrors = false;

        var to = 'translation_form';

        if (!isFormValid) {
          vm.serverErrors = [];

          vm.formErrors = true;
          vm.UtilService.scrollToTop(to);

          return;
        }

        vm.sendingForm = true;

        // console.log(vm.item, language); return;

        HotelContentService.saveHotelContent(vm.item, language).then(function (response) {
          if (response.errors) {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);

            vm.formErrors = true;
            vm.UtilService.scrollToTop(to);
          }

          vm.sendingForm = false;
        });
      }

      // ----- TAGS ----- //

      function getTags(lang) {
        TagService.getTags({ skip_check_role: true, by_lang: lang }).then(function (data) {
          vm.tags = data.items;
        });
      }

      function tagTransform(name) {
        return TagService.tagTransform(name, vm.languageSelected);
      }

      function checkTagOptions(tag) {
        vm.tagOptions = TagService.checkTagOptions(tag, vm.tags);
      }
    }
  }
})();
